import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Disable scrolling when menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('navbar-menu-open');
        } else {
            document.body.classList.remove('navbar-menu-open');
        }
    }, [isOpen]);

    return (
        <nav className="navbar-component">
            <div className="navbar-container-component">
              <Link to="/">  <img src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1736775982/Untitled_design_9_qj2els.webp" alt="Apex Logo" className="navbar-logo-component" /></Link>
                <div className="navbar-heading-component">
                    <h1 className="navbar-title-component">The Golden Palace</h1>
                    <p className="navbar-subtitle-component">
                        A Luxuries Marriage Garden & Resort
                    </p>
                </div>
                <button className="menu-toggle-component" onClick={toggleMenu}>
                    <span className={isOpen ? "menu-bar-component open" : "menu-bar-component"}></span>
                    <span className={isOpen ? "menu-bar-component open" : "menu-bar-component"}></span>
                    <span className={isOpen ? "menu-bar-component open" : "menu-bar-component"}></span>
                </button>
                <ul className={`nav-links-component ${isOpen ? "open" : ""}`}>
                    <li><a href="/about" className="nav-link-component">ABOUT</a></li>
                    <li><a href="/hotel-rooms" className="nav-link-component">ACCOMMODATION</a></li>
                    <li><a href="/facilities" className="nav-link-component">FACILITIES</a></li>
                    <li><a href="/banquite-facilities" className="nav-link-component">BANQUITE FACILITIES</a></li>
                    <li><a href="/recreational-facilities" className="nav-link-component">RECREATIONAL FACILITIES</a></li>
                    <li><a href="/outdoor" className="nav-link-component">OUTDOOR</a></li>
                    <li><a href="/amenties" className="nav-link-component">AMENTIES</a></li>
                    <li><a href="/gallery" className="nav-link-component">GALLERY</a></li>
                    
                    <li><a href="/contact" className="nav-link-component">CONTACT US</a></li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
